export default window.location.origin.indexOf("sgd-group.com") >= 0
  ? "https://storage.googleapis.com/public-assets-iot-uta/web/logo-saputa.png"
  : "https://storage.googleapis.com/public-assets-iot-uta/web/Logo%20EcoZanz.png";
